import { useState } from 'react';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import Link from '@mui/material/Link';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import DownloadListItem from './DownloadListItem';
import KeynomeManagerDownloadInstructions from './KeynomeManagerDownloadInstructions.jsx';
import { LicenseText } from './LicenseText.jsx';

const styles = {
  profileHeader: {
    backgroundColor: '#eee',
    padding: '1px 0px 1px 10px'
  },
  apiKeysList: {
    width: '100%',
    bgcolor: 'background.paper',
    paddingTop: '0',
    paddingBottom: '0'
  },
};

function KeynomeManagerDownload() {
  const [licensesOpen, setLicensesOpen] = useState(false);
  
  return (
    <>
    <Box sx={{ ...styles.profileHeader, display: 'flex', alignItems: 'center' }}>
      <p><b>Download Keynome Manager</b></p>
      <Link 
        component="button"
        variant="body2"
        onClick={() => setLicensesOpen(true)}
        sx={{ color: 'text.secondary', marginLeft: 'auto', marginRight: '10px' }}
      >
        Licenses
      </Link>
    </Box>
      <Box>
        <List sx={styles.apiKeysList}>
          <DownloadListItem platform="windows" />
          <DownloadListItem platform="linux" />
          <DownloadListItem platform="macos_intel" />
          <DownloadListItem platform="macos_arm64" />
        </List>
      </Box>
      <Dialog
        open={licensesOpen}
        onClose={() => setLicensesOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{ backgroundColor: '#eee' }}>Licenses</DialogTitle>
        <DialogContent>
          <pre style={{ 
            whiteSpace: 'pre-wrap', 
            wordWrap: 'break-word',
            fontFamily: 'monospace',
            fontSize: '0.875rem'
          }}>
            {LicenseText}
          </pre>
        </DialogContent>
        <DialogActions sx={{ backgroundColor: '#eee' }}>
          <Button onClick={() => setLicensesOpen(false)}>Close</Button>
        </DialogActions>
      </Dialog>
      <KeynomeManagerDownloadInstructions />
    </>
  );
}

export default KeynomeManagerDownload;
